import { Col, Row } from "antd";
import { useRouteMatch } from "react-router";
import { Box, Flex } from "@chakra-ui/layout";
import { useBreadcrumb } from "features/breadcrumbs";
import { useState } from "react";
import MenuDetalhes from "components/Menu/MenuDetalhes";
import { TabMenuOptions, TabsMenuOptionsRoutes } from "./typings";
import history from "infra/helpers/history";
import CardDefault from "components/Cards/CardDefault";
import { useLocation } from "react-router-dom";
import PageHeader from "components/Page/PageHeader";
import Container from "components/Container";
import DadosCadastrais from "./components/DadosCadastrais";
import DadosEndereco from "./components/DadosEndereco/index";
import Impostos from "./components/Impostos/index";
import Tributacao from "./components/Tributacao/index";
import useFornecedorPessoa from "core/features/fornecedores/hooks/useFornecedorPessoa";
import { PessoaTipo } from "core/features/pessoas/typings";

function FornecedorDetalhesPage() {
  const route = useRouteMatch<{ id: string; tenant: string }>();

  useBreadcrumb([
    { name: "Cadastros", url: "/cadastros" },
    { name: "Fornecedores", url: "/cadastros/fornecedores" },
    {
      name: route.params.id ? "Editar Fornecedor" : "Cadastrar Novo Fornecedor",
    },
  ]);

  const { search } = useLocation();

  const params = new URLSearchParams(search);
  const { data } = useFornecedorPessoa(route.params.id);
  const opcaoParam = !route.params.id
    ? TabsMenuOptionsRoutes.Dados
    : (params.get("opcao") as string) || TabsMenuOptionsRoutes.Dados;

  const [selectedMenuOption, setSelectedMenuOption] = useState(opcaoParam);

  const handleChangeMenu = (tab: string) => {
    setSelectedMenuOption(tab);

    if (route.params.id) {
      history.push(`/cadastros/fornecedores/${route.params.id}?opcao=${tab}`);
    } else {
      history.push(`/cadastros/fornecedores/new?opcao=${tab}`);
    }
  };

  if (!opcaoParam) {
    return null;
  }

  return (
    <Container pb="32px">
      <PageHeader
        title={
          <Flex gap="8px" fontWeight="bold">
            {route.params.id ? "Editar " : "Cadastrar Novo "}
            Fornecedor
          </Flex>
        }
      />

      <Row gutter={32}>
        <Col sm={6}>
          <Box mb={4} pt="0px" flex={1}>
            <MenuDetalhes<TabsMenuOptionsRoutes>
              disabledOptions={
                !route.params.id
                  ? [
                      TabsMenuOptionsRoutes.Endereco,
                      //   TabsMenuOptionsRoutes.Contratos,
                      //   TabsMenuOptionsRoutes.ContasBancarias,
                      TabsMenuOptionsRoutes.Impostos,
                      TabsMenuOptionsRoutes.Tributacao,
                    ]
                  : []
              }
              filteredOptions={
                !data || data?.pessoaTipo === PessoaTipo.Juridica
                  ? undefined
                  : [TabsMenuOptionsRoutes.Tributacao]
              }
              options={TabMenuOptions}
              selectedOption={selectedMenuOption as TabsMenuOptionsRoutes}
              onChangeOption={(tab) => {
                handleChangeMenu(tab);
              }}
            />
          </Box>
        </Col>

        <Col sm={18}>
          {selectedMenuOption === TabsMenuOptionsRoutes.Dados ? (
            <CardDefault>
              <DadosCadastrais
                id={route.params.id}
                isEdit={!!route.params.id}
              />
            </CardDefault>
          ) : null}

          {selectedMenuOption === TabsMenuOptionsRoutes.Endereco ? (
            <CardDefault>
              <DadosEndereco id={route.params.id} isEdit={!!route.params.id} />
            </CardDefault>
          ) : null}

          {selectedMenuOption === TabsMenuOptionsRoutes.Contratos ? (
            <CardDefault></CardDefault>
          ) : null}

          {selectedMenuOption === TabsMenuOptionsRoutes.ContasBancarias ? (
            <CardDefault></CardDefault>
          ) : null}

          {selectedMenuOption === TabsMenuOptionsRoutes.Impostos ? (
            <CardDefault>
              <Impostos id={route.params.id} />
            </CardDefault>
          ) : null}

          {selectedMenuOption === TabsMenuOptionsRoutes.Tributacao &&
          (!data || data?.pessoaTipo === PessoaTipo.Juridica) ? (
            <CardDefault>
              <Tributacao id={route.params.id} />
            </CardDefault>
          ) : null}
        </Col>
      </Row>
    </Container>
  );
}

export default FornecedorDetalhesPage;
